module.exports = __webpack_public_path__ + "static/media/Sharp-LS013B7DH05-Mechanical-Drawing.c5c2e5f3.png";